import React from "react";
import { STableRow, SFirstColumnCell, SCell, SBar } from "./styles";
import { useCurrency } from "../../../../store";
import { formatPercentage, formatMoney } from "../../../../utils";

interface RentabilityTableRowPropsType {
  asset: {
    color: string;
    label: string | null;
    key: string;
    month: string | null;
    yearToDate: string | null;
    sixMonths: string | null;
    year: string | null;
    selectedPeriod: string | null;
    participation: string | null;
    initialBalance: string | null;
    grossBalance: string | null;
  };
  indented?: boolean;
}

export const RentabilityTableRow: React.FC<RentabilityTableRowPropsType> = ({
  asset,
  indented,
}) => {
  RentabilityTableRow.defaultProps = {
    indented: false,
  };

  const { currency } = useCurrency();

  return (
    <STableRow key={`inner-rentability-${asset.key}`}>
      <SFirstColumnCell>
        <SBar $barColor={asset.color} />
        {indented && <span>&nbsp;&nbsp;&nbsp;</span>}
        {asset.label}
      </SFirstColumnCell>
      <SCell>{formatPercentage(asset.month)}</SCell>
      <SCell>{formatPercentage(asset.yearToDate)}</SCell>
      <SCell>{formatPercentage(asset.sixMonths)}</SCell>
      <SCell>{formatPercentage(asset.year)}</SCell>
      <SCell>{formatPercentage(asset.selectedPeriod)}</SCell>
      <SCell>{formatPercentage(asset.participation)}</SCell>
      <SCell>{formatMoney(asset.initialBalance, currency)}</SCell>
      <SCell>{formatMoney(asset.grossBalance, currency)}</SCell>
    </STableRow>
  );
};
